module.exports = __webpack_public_path__ + "images/ec352319e1376b29031fece81f1f61c8.jpg";